import { useId, type ReactNode } from 'react';
import styles from '../FloodSimSettings.module.css';

interface SettingsSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export default function SettingsSection({ title, description, children }: SettingsSectionProps) {
  const headingId = useId();

  return (
    <section className={styles.section} aria-labelledby={headingId}>
      <header className={styles['section-header']}>
        <h4 id={headingId} className={styles['section-title']}>
          {title}
        </h4>
        {description ? <p className={styles['section-description']}>{description}</p> : null}
      </header>
      <div className="d-flex flex-column gap-3">{children}</div>
    </section>
  );
}
